import IconButton from 'components/common/IconButton';
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ButtonFinish = ({
  funcion,
  data,
  disabled,
  text,
  className,
  justify
}) => {
  return text ? (
    <Button
      className={
        className + ' d-flex align-items-center justify-content-center'
      }
      variant={!disabled ? 'light' : 'secondary'}
      size="sm"
      disabled={disabled}
      onClick={data ? () => funcion(data) : funcion}
      type="submit"
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <div
        className={`w-100 d-flex align-items-center justify-content-${justify} gap-1`}
      >
        <FontAwesomeIcon icon="flag-checkered" style={{ marginRight: 5 }} />
        <span style={{ marginRight: 10 }}>{text}</span>
      </div>
    </Button>
  ) : (
    <OverlayTrigger placement="bottom" overlay={<Tooltip>Finalizar</Tooltip>}>
      <span>
        <IconButton
          buttonSize="sm"
          style={{ width: 30 }}
          icon="flag-checkered"
          onClick={
            !disabled ? (data ? () => funcion(data) : funcion) : () => {}
          }
          variant="light"
          className="px-2"
          disabled={disabled}
        />
      </span>
    </OverlayTrigger>
  );
};

ButtonFinish.propTypes = {
  funcion: PropTypes.func.isRequired,
  data: PropTypes.any,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  className: PropTypes.string,
  justify: PropTypes.oneOf(['start', 'center', 'end'])
};

ButtonFinish.defaultProps = {
  justify: 'start'
};

export default ButtonFinish;
